import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import ContactUs from "../Components/ContactUs/ContactUs";

function Contact() {
  return (
    <>
      <Navbar />
      <ContactUs />
      <Footer />
    </>
  );
}

export default Contact;
